import { FormEvent, useEffect, useRef, useState } from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import ReCAPTCHA from 'react-google-recaptcha'

import edhrecap from '@/assets/edhrecap.png'
import Container from '@/components/Container/Container'
import { ExplicitHead } from '@/components/DefaultHead/DefaultHead'
import Header from '@/components/Header/Header'
import Icon from '@/components/Icon/Icon'
import Panel from '@/components/Panel/Panel'
import requestService from '@/services/request.service'
import { useAppSelector } from '@/store/hooks'
import { recaptchaKey } from '@/utils/constants'

const Newsletter = () => {
  const user = useAppSelector((state) => state.user)
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const recaptchaRef = useRef<ReCAPTCHA>(null)

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    event.stopPropagation()

    if (success) return

    event.currentTarget.checkValidity()

    if (recaptchaRef.current) {
      const recaptchaValue = recaptchaRef.current.getValue()
      if (!recaptchaValue) {
        setError('Please complete the captcha.')
        return
      }

      setError('')
      setIsLoading(true)
      try {
        const resp = await requestService.post('/api/newsletter', { email, token: recaptchaValue })
        if (resp.success) {
          setSuccess(true)
        } else {
          setError(resp.error)
        }
      } catch (error: any) {
        setError(error.message)
      }
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (user.email) setEmail(user.email)
  }, [user.email])

  return (
    <Container small>
      <ExplicitHead
        title='Newsletter | EDHREC'
        description='EDHRECap - EDHREC Newsletter'
        keywords='EDHREC,EDHRECap,newsletter'
      />
      <img alt='EDHRECap' className='mb-3 rounded' src={edhrecap.src} />
      <Panel>
        <form className='d-grid gap-3 pb-3' onSubmit={onSubmit}>
          <Header className='m-0'>Subscribe to our newsletter!</Header>
          <p className='m-0'>
            Don&apos;t miss a thing! Get weekly emails with all the best new content, site updates, and more, on EDHREC.
          </p>
          <Form.Group>
            <Form.Label htmlFor='email'>Email</Form.Label>
            <Form.Control id='email' onChange={(e) => setEmail(e.target.value)} required type='email' value={email} />
          </Form.Group>
          <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey} />
          <Button disabled={isLoading} size='lg' type='submit' variant={success ? 'success' : 'primary'}>
            {success ? <Icon icon='check' /> : isLoading ? <Spinner size='sm' animation='border' /> : 'Subscribe'}
          </Button>
          {error && <Alert variant='danger'>{error}</Alert>}
        </form>
      </Panel>
    </Container>
  )
}

export default Newsletter
